import shippingServiceButtonHtml from './shippingServiceButton.component.html';

class ShippingServiceButtonController {
    constructor($scope, ModalService, ShippingServiceService) {
        'ngInject';

        this.$scope = $scope;
        this.ModalService = ModalService;
        this.service = ShippingServiceService;
    }

    openModal() {
        this.service.reset();

        const modalRef = this.ModalService.add(
            null,
            `<shipping-service-modal></shipping-service-modal>`,
            null,
            true,
            'shipping-service-modal'
        );

        modalRef.open();
        this.$scope.$applyAsync();
    }
}

let shippingServiceButtonComponent = {
    bindings: {},
    template: shippingServiceButtonHtml,
    controller: ShippingServiceButtonController
};

export default shippingServiceButtonComponent;